// Saat dilimi seçicilerinin TEK listesi (PM Ayarları sessiz saatler + Şirket Ayarları kiracı
// saat dilimi). Yalnız IANA adları (istemcilerin Intl API'leri Windows adlarını tanımaz).
// Sunucu kiracı dilimini AYNI beyaz listeyle doğrular (backend Common/TimeZoneIds.TenantAllowedIds;
// eşitliği TenantTimeZoneWhitelistTests bu dosyayı okuyarak sabitler — ikisini BİRLİKTE değiştir).
// Yalnız UTC ofseti ≥ 0 dilimler: kiracı-yerel gün süzgeci (DateRangeFilter.ResolveLocalDays)
// negatif ofsette yanlış güne düşer; sunucu bunları listede olsa bile reddeder.
export const DEFAULT_TIME_ZONE_ID = 'Europe/Istanbul';

export const TIME_ZONE_IDS = ['Europe/Istanbul', 'Europe/Moscow', 'Asia/Almaty', 'Asia/Baku', 'UTC'];

// GenericSelect seçenekleri. Kayıtlı değer listede yoksa (eski/elle girilmiş) başa eklenir —
// aksi hâlde seçici boş görünür ve kaydetmek değeri sessizce değiştirirdi.
export function timeZoneOptions(currentId) {
  const ids = currentId && !TIME_ZONE_IDS.includes(currentId)
    ? [currentId, ...TIME_ZONE_IDS]
    : TIME_ZONE_IDS;
  return ids.map((id) => ({ id, name: id }));
}
